import client from "../../../api/client";

export default async function getCommunityPreferences() {
  const response = await client.get("/master/community-preferences");
  return response.data;
}